import styled from 'styled-components';

const OpacityBoxStyled = styled.section`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export { OpacityBoxStyled };
